export function operationMatches(token, currentToken, organisationId, currentOrganisationId) {
  return token === currentToken && organisationId === currentOrganisationId;
}
